import {
  Formik,
} from 'formik';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Modal,
  Button,
} from 'web-components';

type Props = {
  modal: {
    icon?: string;
    title: string;
    isOpen: boolean;
    bodyText: string;
    helpText?: string
    hideCancel: boolean;
    cancelText: string;
    confirmText: string;
  }
  onRequestClose: { (): void };
  onRequestConfirm: { (data: any, actions: any): void };
};

const ConfirmModal = ({
  modal,
  onRequestClose,
  onRequestConfirm,
}: Props) => (
  <Modal
    title={modal.title || 'Confirm'}
    isOpen={modal.isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{}}
      onSubmit={onRequestConfirm}
    >
      {(formikProps) => (
        <Flex
          column
          as="form"
          width="100%"
          align="center"
          spacing={15}
          onSubmit={formikProps.handleSubmit}
        >
          <Text
            align="center"
            dangerouslySetInnerHTML={{
              __html: modal.bodyText || 'Are you sure?',
            }}
          />
          <Flex spacing={10}>
            {!modal.hideCancel && (
              <Button
                ghost
                spacing="large"
                appearance="danger"
                onClick={onRequestClose}
              >
                {modal.cancelText || 'Cancel'}
              </Button>
            )}
            <Button
              ghost
              type="submit"
              spacing="large"
              appearance="primary"
              isLoading={formikProps.isSubmitting}
              isDisabled={formikProps.isSubmitting}
            >
              {modal.confirmText || 'Confirm'}
            </Button>
          </Flex>
          {modal.helpText && (
            <Flex width="100%" column>
              <hr style={{ marginBottom: 15 }} />
              <Text color="#9EA0A1" dangerouslySetInnerHTML={{ __html: modal.helpText }} />
            </Flex>
          )}
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default ConfirmModal;
